import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import useAuthStore from "../../stores/useAuthStore";
import useLanguageStore from "../../stores/useLanguageStore";

function MobileLogout() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const signOut = useAuthStore((state) => state.signOut);
  const currentLanguage = useLanguageStore((state) => state.language);
  const setLanguage = useLanguageStore((state) => state.setLanguage);

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  var role = localStorage.getItem("role") ? localStorage.getItem("role") : "";
  var email = localStorage.getItem("email");
  var displayRole = "Views.Header.DisplayLoginRole" + role;

  if (role !== "") {
    return (
      <ButtonDropdown
        id="mobile__logout"
        isOpen={dropdownOpen}
        toggle={toggle}
      >
        <DropdownToggle id="mobile__logout-toggler" title="Info">
          <FontAwesomeIcon icon="user" style={{ cursor: "pointer" }} />
        </DropdownToggle>
        <DropdownMenu id="mobile__logout-menu">
          <DropdownItem header>
            <FormattedMessage id="Views.Header.DisplayLoginRole" />
            &nbsp;{email} (<FormattedMessage id={displayRole} />)
          </DropdownItem>
          <DropdownItem divider />
          {role === "Teacher" ? (
            <>
              <DropdownItem tag={Link} to="/teacher/myaccount">
                <FormattedMessage id="MyAccount" />
              </DropdownItem>
              <DropdownItem divider />
            </>
          ) : (
            ""
          )}
          <DropdownItem
            active={currentLanguage === "sv"}
            onClick={() => setLanguage("sv")}
          >
            Svenska
          </DropdownItem>
          <DropdownItem
            active={currentLanguage === "en"}
            onClick={() => setLanguage("en")}
          >
            English
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={signOut}>Logga ut</DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    );
  } else {
    return null;
  }
}

export default MobileLogout;
